<template>
  <div class="container_j d-none d-md-block" :class="{'collapsed':appStates.collapsedSidebar }">
    <div class="d-flex h-100 flex-column">
      <div class="container m-0 container-tasto-nuovo">
        <div
          @click="$router.push('?intent=new')"
          class="tasto-nuovo d-flex align-items-center justify-content-center"
        >
          <span class="tracking-in-expand" v-if="!appStates.collapsedSidebar">{{ label_nuovo}}</span>
          <span style="font-size:3vh;" v-if="appStates.collapsedSidebar">+</span>
        </div>
      </div>
      <div class="flex-grow-1">
        <div v-if="!appStates.collapsedSidebar" class="fade-in separatore">Navigazione</div>

        <div class="menu">
          <ul class="nav flex-column">
            <li
              v-for="link in orderedLinks"
              v-show="link.visibility"
              disabled
              :key="link.key"
              @click="dinamicFunctionHandle(link.clickAction)"
              class="nav-item"
              :class="link.specificCssClass"
            >
              <div class="container">
                <router-link
                  v-if="link.type !=='extern'"
                  class="link-barra-laterale row"
                  :class="{ 'router-link-active': $route.name === link.destination}"
                  :to="link.destination"
                >
                  <!--<img :src=" require('../assets/'+link.imgSrc) ">-->
                  <div class="container-icona">
                    <i
                      style="display:inline-block;"
                      class="fas sezione"
                      :class="link.fontAwesomeIcon"
                    ></i>
                  </div>
                  <p class="tracking-in-expand" v-if="mostraTitolo">{{link.title}}</p>
                  <router-link
                    class="tasto_piu"
                    v-if="!appStates.collapsedSidebar"
                    :to="link.destinationPlusButton"
                  >
                    <i class="fas fa-plus-circle piu"></i>
                  </router-link>
                  <ul v-show="false">
                    <li v-for="child in link.children" :key="child.id">
                      <router-link class="new" :to="link.destinationPlusButton">
                        <span>child.title</span>
                      </router-link>
                    </li>
                  </ul>
                </router-link>
                <a
                  v-if="!appStates.collapsedSidebar && link.type === 'extern'"
                  class="link-barra-laterale row"
                  target="_blank"
                  :href="link.destination"
                >{{link.title}}</a>
              </div>
            </li>
          </ul>
        </div>
        <!--NON SI CAPISCE PERCHE MA QUESTA RIGA BLOCCA LE ANIMAZIONI NELLE ICONE SE CI SONO-->
        <div v-if="!appStates.collapsedSidebar" class="fade-in separatore">Oggi</div>

        <div v-if="!appStates.collapsedSidebar" class="fade-in container-report">
          <div class="title-report tracking-in-expand">Totale Ordini</div>
          <div class="report tracking-in-expand">{{ (ordersQTY || 0)}}</div>
          <div class="title-report tracking-in-expand">Incasso</div>
          <div class="report tracking-in-expand">{{ (incoming || 0) | arrotonda }}€</div>
          <div class="title-report tracking-in-expand">Totale Utile</div>
          <div class="report tracking-in-expand">{{ (profit || 0) | arrotonda }}€</div>
          <div class="title-report tracking-in-expand">Valore Magazzino</div>
          <div class="report tracking-in-expand">{{ (stockWorth || 0) | arrotonda }}€</div>
        </div>
      </div>

      <div style="height:4vh;">
        <button
          @click="appStates.collapsedSidebar = !appStates.collapsedSidebar"
          class="collapse_btn"
        >
          <i v-if="!appStates.collapsedSidebar" class="fas fa-angle-left"></i>
          <i v-if="appStates.collapsedSidebar" class="fas fa-angle-right"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
const state = {};

import { EventBus } from "../main.js";
import { jStore } from "../store/jestionaleStore.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Sidebar",
  props: {
    appStates: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      oggi: "",
      timeOut: "",
      mostraTitolo: true,
      settings: {
        //lorem
      },
      userSpecificSettings: {
        //lorem
      },
      links: {
        /*
         //QUANDO SI CREA UNA PAGINA RICORDARSI DI AGGIUNGERLA in router.js
          SAMPLE PAGE SETTINGS
          pageNameOrId: {
          imgSrc: "img/sidebar/listino.png",
          destination: "listini",
          destinationPlusButton: "listini?intent=new",
          title: "Listino",
          //come parametro passare il nome di una funzione che deve eseguire al click
          clickAction: "",
          //come parametro passare il nome di una funzione che deve eseguire al click tasto più
          clickActionPlusButton: "",
          order: 1,
          visibility: true,
          unreadNotifications: 0,
          childrenLinks: {},
          specificCssClass:""
        }
        */
        pageOrdini: {
          imgSrc: "img/sidebar/clienti.png",
          fontAwesomeIcon: "fa-archive",
          destination: "ordini",
          destinationPlusButton: "ordini?intent=new",
          title: "Ordini",
          order: 1,
          nuovo: "Nuovo Ordine",
          visibility: true
        },
        pageCrudTableListino: {
          imgSrc: "img/sidebar/documenti.png",
          fontAwesomeIcon: "fa-tags",
          destination: "listini",
          destinationPlusButton: "listini?intent=new",
          title: "Elenco Listini",
          order: 4,
          visibility: true,
          nuovo: "Nuovo Listino"
        },
        pageCrudTableMagazzino: {
          imgSrc: "img/sidebar/magazzino.png",
          fontAwesomeIcon: "fa-warehouse",
          destination: "magazzino",
          destinationPlusButton: "magazzino?intent=new",
          title: "Magazzino",
          order: 5,
          visibility: true,
          nuovo: "Nuovo Prodotto"
        },
        pageStatistiche: {
          imgSrc: "img/sidebar/magazzino.png",
          fontAwesomeIcon: "fa-chart-pie",
          destination: "statistiche",
          destinationPlusButton: "",
          title: "Statistiche",
          order: 6,
          visibility: true,
          nuovo: "Nuovo Obbiettivo"
        }
        /*
        link_esterno: {
          type: "extern",
          imgSrc: "img/sidebar/magazzino.png",
          destination: "http://www.google.it",
          title: "Google",
          order: 5,
          visibility: true
        },
        link_esterno2: {
          type: "extern",
          imgSrc: "img/sidebar/magazzino.png",
          destination: "https://vuejs.org/v2/api/",
          title: "Vue Documentation",
          order: 6,
          visibility: true
        },
        link_esterno3: {
          type: "extern",
          imgSrc: "img/sidebar/magazzino.png",
          destination:
            " https://console.firebase.google.com/u/1/project/jestionale-bfde2/database/jestionale-bfde2/data",
          title: "Firebase Sorin",
          order: 7,
          visibility: true
        },
        link_esterno4: {
          type: "extern",
          imgSrc: "img/sidebar/magazzino.png",
          destination: "https://lodash.com/docs/4.17.11",
          title: "Lodash",
          order: 7,
          visibility: true
        }**/
      }
    };
  },
  computed: {
    ...mapGetters({
      stockWorth: "sideBarStates/stockWorth",
      orderObj: "ordineStates/orderObj",
      ordersQTY: "sideBarStates/ordersQTY",
      profit: "sideBarStates/profit",
      incoming: "sideBarStates/incoming"
    }),
    //https://lodash.com/docs/4.17.11#orderBy
    orderedLinks() {
      return _.orderBy(this.links, "order", "asc");
    },
    label_nuovo() {
      let self = this;
      if (this.$route.name) {
        var index = this.orderedLinks.findIndex(
          s => s.destination.toLowerCase() === self.$route.name.toLowerCase()
        );
        return this.orderedLinks[index]
          ? this.orderedLinks[index].nuovo
          : console.error("$ROUTE.name NON VALIDA PER COSTRUIRE LABEL");
      }
    }
  },
  methods: {
    dinamicFunctionHandle(fxName) {
      if (typeof fxName === "function") this[fxName]();
      //else console.log("Parameter non function or not defined.S.L");
    },
    //SERVE  IN MODO CHE A MEZZANOTTE VENGA RIFRESHATA LA SIDEBAR
    setMidnightReload() {
      let self = this;
      this.oggi = new Date().getDate();
      let adesso = Date.now();
      var domani = new Date();
      domani.setDate(domani.getDate() + 1);
      domani.setHours(0, 0, 0, 0);
      let target = domani - adesso;
      this.timeOut = setTimeout(self.getStats, target);
    },
    getStats() {
      //DOVREI IN QUALCHE MODO FARE ANCHE IN MODO CHE
      //SE NON C'E CONNESSIONE DI RETE L'APP RIMANE IN ATTESA
      //DI RISTABILIRE LA CONNESSIONE E POI RIESEGUE IL CARICAMENTO DELLE STATS
      let self = this;

      this.$store.commit("sideBarStates/getToday");
      this.$store.dispatch("sideBarStates/getStockWorth").then(function() {
        self.$store.dispatch("sideBarStates/copyStockValue");
      });
      this.$store.dispatch("sideBarStates/getOrdersQTY");
      this.$store.dispatch("sideBarStates/getProfit");
      this.$store.dispatch("sideBarStates/getIncoming");
      this.setMidnightReload();
    }
  },
  filters: {
    arrotonda: function(str) {
      let numero = str;

      numero = parseFloat(numero).toFixed(2);
      numero = numero.toString();
      numero = numero.replace(".", ",");
      return numero;
    }
  },
  mounted() {
    this.getStats();
    //LEGGO IL VALORE DEL MAGAZZINO E UNA VOLTA LETTO
    //SE NON PRESENTE LO COPIO NEL NODO STATISTICHE GIORNALIERO
  },
  created() {
    let self = this;
    //EVENTO CHE CAPTA IL FOCUS SULLA FINESTRA E SE E' UN ALTRO
    //GIORNO AGGIORNA LE STATICHE
    //IN QUESTO MODO TENGO AGGIORNATA LA SIDEBAR
    //ANCHE SE IL PC VA IN STAND BY
    window.addEventListener(
      "focus",
      function(event) {
        let oggi = new Date().getDate();
        if (oggi != this.oggi) {
          self.getStats();
        }
      },
      false
    );
  }
};
</script>

<style lang="scss" scoped>
.fade-in {
  -webkit-animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
  animation: fade-in 1.2s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}
/* ----------------------------------------------
 * Generated by Animista on 2019-4-25 21:47:21
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@-webkit-keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
@keyframes fade-in {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

.collapse_btn {
  position: relative;
  float: right;
  color: white;
  background: none;
  height: 100%;
  border: none;
  text-align: center;
  margin-right: 1vw;
}

.container-report {
  color: white;
  padding-left: 1.7vw;
  padding-top: 1vw;
  -moz-transition: all 0.4s ease-in;
  -o-transition: all 0.4s ease-in;
  -webkit-transition: all 0.4s ease-in;
  transition: all 0.4s ease-in;
}

.collapsed .container-report {
  padding: 0;
  display: flex;
  padding-left: 0.4vw;
  padding-right: 0.4vw;

  flex-direction: column;
}

.collapse_btn:focus {
  outline: none;
}

.title-report {
  font-size: 1.5vh;
  color: #a3a3a3;
}

.collapsed .title-report {
  text-align: center;
}

.report {
  font-weight: bold;
  color: #d3d3d3;
  display: inline-block;
  background-color: #333333;
  padding: 1vh;
  margin-top: 1vh;
  margin-bottom: 1.5vh;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}

.collapsed .report {
  text-align: center;
  font-size: 1.5vh;
}

.separatore {
  color: white;
  margin-top: 1.5vh;
  margin-left: 3vh;
  color: #878787;
  font-size: 2vh;
  font-weight: 100;
  letter-spacing: 0.6px;
}

.container-tasto-nuovo {
  height: 9vh;
  background-color: #039be5;
  -webkit-border-bottom-right-radius: 20px;
  -webkit-border-bottom-left-radius: 20px;
  -moz-border-radius-bottomright: 20px;
  -moz-border-radius-bottomleft: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
  display: block;
  padding: 1.4vh;
}

.collapsed .container-tasto-nuovo {
  padding: 1vh;
}

//ANIMAZIONE INGRESSO TESTO 2 SECONDI DI DELAY E POI 3 SECONDI DI ANIMAZIONE
.tracking-in-expand {
  -webkit-animation: tracking-in-expand 0.3s cubic-bezier(0.215, 0.61, 0.355, 1)
    0.2s both;
  animation: tracking-in-expand 0.3s cubic-bezier(0.215, 0.61, 0.355, 1) 0.2s
    both;
}

@-webkit-keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}
@keyframes tracking-in-expand {
  0% {
    letter-spacing: -0.5em;
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    opacity: 1;
  }
}

.tracking-in-expand-fwd {
  -webkit-animation: tracking-in-expand-fwd 0.5s
    cubic-bezier(0.215, 0.61, 0.355, 1) both;
  animation: tracking-in-expand-fwd 0.5s cubic-bezier(0.215, 0.61, 0.355, 1)
    both;
}

/* ----------------------------------------------
 * Generated by Animista on 2019-4-25 15:13:32
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

@-webkit-keyframes tracking-in-expand-fwd {
  0% {
    letter-spacing: -0.5em;
    -webkit-transform: translateZ(-700px);
    transform: translateZ(-700px);
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}
@keyframes tracking-in-expand-fwd {
  0% {
    letter-spacing: -0.5em;
    -webkit-transform: translateZ(-700px);
    transform: translateZ(-700px);
    opacity: 0;
  }
  40% {
    opacity: 0.6;
  }
  100% {
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    opacity: 1;
  }
}

.tasto-nuovo {
  height: 100%;
  background-color: #0182c1;
  -webkit-border-radius: 20px;
  -moz-border-radius: 20px;
  border-radius: 20px;
  color: white;
  font-weight: bold;
  cursor: pointer;
}

.container-icona {
  width: 2vw;
  text-align: center;
  margin-right: 0.5vw;
}

.container_j {
  position: relative;
  height: 100%;
  width: inherit;
  z-index: 999;
  background-color: #1e272e;
}

.menu {
  padding-left: 0.8vw !important;
  padding-right: 0.8vw !important;
  margin-top: 2vh;

  padding-bottom: 3vh;
}

.collapsed .menu {
  margin-top: 4vh;
}

.tasto_piu {
  background: none !important;
}

.nuovo {
  width: 19vh;
  height: 6vh;
  line-height: 6vh;
  text-align: center;
  border: solid 2px #039be5;
  background-color: none;
  margin-left: 3vh;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
  color: white;
  font-weight: bold;
  margin-bottom: 5vh;
}
.nav {
  padding-left: 0px;
}
.nav-item {
  width: 100%;
}

.nav-item img {
  /*width:1vw !important;
  height:1vw !important;*/
}

.piu {
  color: grey;
  margin-left: 1vw;
  opacity: 0;
  font-size: 2.5vh;
  text-align: center;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
.piu:hover {
  color: white;
}

.container_j .link-barra-laterale {
  font-weight: 500;
  color: white;
  height: 6vh;
  line-height: 6vh;

  padding-left: 1.2vw;
}

.collapsed .link-barra-laterale {
  padding-left: 0px !important;
  height: 7.5vh;
  line-height: 7.5vh !important;
}

.link-barra-laterale:hover {
  text-decoration: none;
  color: white;
}
.link-barra-laterale:hover .piu {
  opacity: 1;
}
.container_j img {
  width: 15px;
  height: auto;
}
.link-barra-laterale i {
  line-height: 6vh;
}

.new {
  color: white;
  text-align: left !important;
}
.router-link-active {
  font-weight: 600;
  color: #4fc3f7;
  background-color: #485460;
  -webkit-border-radius: 10px;
  -moz-border-radius: 10px;
  border-radius: 10px;
}
.sidebar-heading {
  font-size: 0.75rem;
  text-transform: uppercase;
}

/*COLLAPSED SIDEBAR STYLES*/
.menu .collapsed {
  padding-left: 0.6vw !important;
  padding-right: 0.6vw !important;
}

.collapsed .nav-item {
  margin-bottom: 1.5vh;
}

.collapsed p {
  display: none;
}

.collapsed .container-icona {
  line-height: 7.5vh !important;
  margin: 0 auto !important;
  width: 100%;
}

.sezione {
  font-size: 1.2vw;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}

.collapsed .sezione {
  font-size: 2vw;
  line-height: 7.5vh !important;
  margin: 0 auto !important;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  -webkit-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;
}
</style>
